<template>
  <requests-table :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import requestsTable from './table'

export default {
  components: {
    requestsTable
  },
  computed: {
    ...mapState('accessRequests', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/access-requests/pending.vue